import { render, staticRenderFns } from "./TabBar.vue?vue&type=template&id=5e3b9935&scoped=true"
import script from "./TabBar.vue?vue&type=script&lang=ts"
export * from "./TabBar.vue?vue&type=script&lang=ts"
import style0 from "./TabBar.vue?vue&type=style&index=0&id=5e3b9935&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3b9935",
  null
  
)

export default component.exports